import { Tag } from "antd";
import styled from "styled-components";

export const StyledTag = styled(Tag)`
    padding-inline: 5px;
    line-height: 15px;

    .span__prev-apply-amount {
        text-decoration: line-through;
    }
`;
